import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../common/http/http-utils';
import { ClientUtilities } from '../../utils/client-utils';

@Injectable()
export class HybridInterconnectService {

    public isRunningInNGC: boolean = false;
    private apiBase: string;
    private computeProfile: string;

    constructor(public http: HttpClient) {
        this.isRunningInNGC = ClientUtilities.runningInPluginUI();

        const path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
        this.apiBase = (!!path && !!this.isRunningInNGC) ? path + '/hcx-ui/rest' : '';
        this.computeProfile = this.apiBase + '/hybridity/api/interconnect/computeProfiles';
    }

    public getAllComputeProfiles(vcGuid: string, endpoint?: string) {
        let url = HttpUtils.getBaseUrl() + this.apiBase + this.computeProfile;
        if (!!endpoint) {
            url += '?endpointId=' + endpoint + '&vcGuid=' + vcGuid;
        } else {
            url += '?vcGuid=' + vcGuid;
        }
        return this.http.get(url).map((res: any) => res);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/hybrid-interconnect/hybrid-interconnect.service.ts